import React from "react";
import CustomerShowcase from "./CustomerShowcase/CustomerShowcase";
import CustomerFeatures from "./CustomerFeatures/CustomerFeatures";
import CustomerStories from "./CustomerStories/CustomerStories";


function Customers() {
  return <div>
    <CustomerShowcase/>
    <CustomerFeatures/>
    <CustomerStories/> 
  </div>;
}

export default Customers;
